import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AreaTabs } from '@/features/nav/AreaTabs';
import { PageActionsSlot } from '@/features/nav/PageActions';

export const Route = createFileRoute('/_authenticated/people')({
  component: () => (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <h1 className="text-2xl">Nhân sự</h1>
        <PageActionsSlot />
      </div>
      <AreaTabs areaId="people" />
      <Outlet />
    </div>
  ),
});
